import { selectIsDarkTheme } from "@motain/web-shared-hub/services";
import { darkTheme, defaultTheme } from "@motain/web-shared-hub/themes";
import homeDark from "@motain/web-shared-hub/assets/icons/OFLongIconWhite.svg";
import home from "@motain/web-shared-hub/assets/icons/OFLongIconDark.svg";
import { useAppSelector } from "@/shared/hooks/appHooks";

export function useThemeColor() {
  const isDarkMode = useAppSelector(selectIsDarkTheme);
  const ThemeColor = isDarkMode ? darkTheme : defaultTheme;

  return {
    fontColor: ThemeColor.colors.bodyText,
    backgroundColor: ThemeColor.colors.background,
    cardColor: ThemeColor.colors.border,
    successColor: ThemeColor.colors.pitchLineup,
    primaryColor: ThemeColor.colors.brandPrimary,
    loaderColor: ThemeColor.colors.yellowCard,
    errorColor: ThemeColor.colors.redCard,
    logoUrl: isDarkMode ? home : homeDark,
  };
}
